export const ll = (num: number) => {
  return `${num < 0 ? 'max' : 'min'}(calc(${num}px * var(--min-ratio)), calc(${num} / var(--lcqw-base) * 100cqw))`
}